import { jsonldPublisherName } from './JsonldStore';

export const updateJsonldPublisherName = (value) => jsonldPublisherName.update((oldValue) => value);

